import { Landing } from 'features/user/Landing'

export const LandingPage = () => {
    return <Landing></Landing>
}
